import { useParams } from "react-router-dom";
import { Loading, Error } from "ra-ui-materialui";

import useOneMember from "../../../hooks/useOneMember";
import useOneMemberCI from "../../../hooks/useOneMemberCI";
import MemberProfileBaseView from "../components/MemberProfileBaseView";
import useSocials from "../../../hooks/useSocials";
import { useLocale } from "react-admin";
//import { useLocale } from "react-admin";
const SocialInfoView = () => {
  const { id } = useParams();
  const locale = useLocale();
  const { member: ci, loading: ciLoading, error: ciError } = useOneMemberCI(id);
  const { member, loading, error } = useOneMember(id);
  const {
    socials,
    loading: socialsLoading,
    error: socialsError,
    getSocialName,
  } = useSocials();

  if (loading || ciLoading || socialsLoading) return <Loading />;
  if (error || ciError || socialsError) return <Error error={error} />;
  const tabs = [
    {
      title: "",
      blocks: [
        {
          title: "Social Media",
          isArray: true,
          groupKey: "socials",
          datas: [
            {
              key: "id",
              values: ci.socials, //Come from gid,
              text: locale === "th" ? "โซเชียล" : "Social",
              type: "select",
              options: socials,
              valueProperty: "name",
              selectDisplayValueFunctionforIsArray: getSocialName,
            },
            {
              key: "account",
              values: ci.socials, //Come from gid,
              text: locale === "th" ? "บัญชี" : "Account",
              type: "text",
            },
          ],
        },
      ],
    },
  ];

  return (
    <MemberProfileBaseView
      title={"Social Media"}
      tabs={tabs}
      member={member}
      ci={ci}
    />
  );
};

export default SocialInfoView;
